import type { Release } from '../releases.ts';

export default {
  version: '0.5.0',
  date: '2026-09-29',
  title: 'Production readiness',
  summary: [
    'Permissions per member, access groups and restricted assets',
    'More formats: stills, interlaced, rotated and anamorphic video, broadcast audio',
    'Interrupted jobs recover, and a storage integrity check',
    'A faster Library at 200,000 assets',
    'External transcoder integration and a Helm chart',
  ],
  features: [
    'Granular permissions: per-member grants, access groups and restricted assets',
    'Broader formats: stills, interlaced, rotated and anamorphic video, broadcast audio layouts',
    'Recovery of interrupted jobs and a storage integrity check',
    'Faster library at 200,000 assets',
    'External transcoder integration (with a simulator)',
    'Helm chart for cloud and on-premises installs',
  ],
  fixes: [],
} satisfies Release;
